import { ContractMessage } from '../../../../types/ContractMessage';
import { DropdownMenu } from '../../../cdl/DropdownMenu/DropdownMenu';
import { IconButton } from '../../../cdl/IconButton/IconButton';
import { IconDots } from '../../../common/icons/cdl/Dots';
import { ContractDeactivateConfirmModal } from '../../../contracts/common/components/ContractDeactivateConfirmModal';
import { useContractActions } from '../../../contracts/common/hooks/useContractActions';

interface ContractRowActionsMenuProps {
    contract: ContractMessage;
    onDelete: (contract: ContractMessage) => void;
}

export const ContractRowActionsMenu = ({ contract, onDelete }: ContractRowActionsMenuProps) => {
    const {
        options,
        prefetchDraftAwardValidation,
        isDeactivateConfirmOpen,
        closeDeactivateConfirm,
        deactivateContract,
        isDeactivating,
    } = useContractActions({
        contract,
        includeEditActionInMenu: true,
        onDelete,
    });

    return (
        <>
            <DropdownMenu
                align="end"
                trigger={
                    <IconButton
                        Icon={IconDots}
                        onMouseEnter={prefetchDraftAwardValidation}
                        onFocus={prefetchDraftAwardValidation}
                        onPointerDown={prefetchDraftAwardValidation}
                    />
                }
                options={options}
            />
            <ContractDeactivateConfirmModal
                isOpen={isDeactivateConfirmOpen}
                onDismiss={closeDeactivateConfirm}
                onConfirm={deactivateContract}
                isSubmitting={isDeactivating}
            />
        </>
    );
};
